import React from 'react';
import EventItem from '../EventItem';

import Box from '@mui/material/Box';

function TopList(props) 
{

  console.log(props.title)
  if (!Array.isArray(props.events) || props.events.length === 0) {
    return null;
  }

  if (props.masterTags) {
    return (
      <>
        <Box
          sx={{
            padding: '8px 12px',
            margin: '24px 4px 8px 4px',
            backgroundColor: '#e0e0e0',
            borderRadius: '6px',
            fontWeight: 'bold',
            fontSize: '16px',
            color: '#333',
          }}
        >
        {props.title}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '16px',
          padding: '8px 0',
        }}
      >
        {props.events.map((ev) => {
  console.log('EventItem key:', ev.id, 'title:', props.title); // ←これを追加


          const useDialog = !(props.user?.join_events?.[ev.id] !== undefined || ev.owner_id === props.user?.id);

          return (
            <EventItem
              key={ev.id}
              event={ev}
              masterTags={props.masterTags}
              updateMasterTags={props.updateMasterTags}
              useDialog={useDialog}
              user={props.user}
            />
          );
        })}
      </Box>
      </>
    );
  } else {
    console.log(props.events)

  }
}

export default TopList;
